import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetScenarioAiLatestReviewQuery = (
  workspaceId?: string,
  scenarioId?: string,
  refetch = false
) => {
  const { prototypes } = useAvApi();

  const data = useQuery({
    queryKey: ['scenario-ai-latest-review', scenarioId],
    queryFn: async () => {
      if (!scenarioId || !workspaceId) return;
      const { data } =
        await prototypes.getV2ProjectsPrototypesAiReviewsLatestByProjectIdAndPrototypeId(
          { projectId: workspaceId, prototypeId: scenarioId },
          { statuses: ['COMPLETED', 'CANCELED', 'IN_PROGRESS'] }
        );

      return data;
    },
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchInterval: refetch ? 3000 : undefined
  });

  return data;
};
